<template>
  <el-container class="view-content">
    <el-header class="header-content">
      <el-form :model="searchItem" label-width="auto" inline size="small">
        <el-form-item label="创建日期">
          <date-range-picker :start.sync="searchItem.start_at" :end.sync="searchItem.end_at" type="before" width="230px"/>
        </el-form-item>
        <el-form-item label="商户ID">
          <el-input v-model.trim="searchItem.shop_id" clearable></el-input>
        </el-form-item>
        <el-form-item label="商户码">
          <el-input v-model.trim="searchItem.code" clearable></el-input>
        </el-form-item>
        <el-form-item label="门店名称">
          <el-input v-model.trim="searchItem.name" clearable></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model.trim="searchItem.mobile" clearable></el-input>
        </el-form-item>
        <el-form-item label="地区">
          <region-cascade v-model="searchItem.region" clearable/>
        </el-form-item>
<!--        <el-form-item label="收款模式">-->
<!--          <el-select v-model="searchItem.settlement_mode" clearable>-->
<!--            <el-option v-for="item in settlementMode" :key="item.id" :value="item.id" :label="item.msg"></el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
      <el-row type="flex" justify="space-between" align="middle">
        <statistics :count-list="countList"/>
        <el-button-group>
          <el-button size="small" type="primary" @click="add">添加商家</el-button>
        </el-button-group>
      </el-row>
    </el-header>
    <el-main class="main-content">
      <vue-table :table-data="tableData">
        <template slot="region" slot-scope="scope">
          <span>{{formatRegion(scope.row)}}</span>
        </template>
        <template slot="user_count" slot-scope="scope">
          <span>{{`${scope.row.user_total} / ${scope.row.user_online}`}}</span>
        </template>
        <template slot="device_count" slot-scope="scope">
          <span>{{`${scope.row.device_total} / ${scope.row.device_online}`}}</span>
        </template>
        <template slot="sms_count" slot-scope="scope">
          <span>{{`${scope.row.sms_count} / ${scope.row.sms_used}`}}</span>
        </template>
        <template slot="auth_count" slot-scope="scope">
          <span>{{`${scope.row.user_count} / ${scope.row.user_used}`}}</span>
        </template>
        <template slot="operate" slot-scope="scope">
          <el-button type="text" @click="showAdmin(scope.row)">查看</el-button>
        </template>
        <template slot="actionBar">
          <el-table-column align="center" label="操作栏" :resizable="false" width="120">
            <template slot-scope="scope">
              <el-button type="text" @click="remote(scope.row)">登录</el-button>
              <el-button type="text" @click="revise(scope.row)">修改</el-button>
              <el-tooltip effect="light" placement="left">
                <div slot="content">
<!--                  <el-button type="text" @click="showGive(scope.row)">增加授权</el-button>-->
                  <el-button type="text" @click="updateUser(scope.row)">更新用户</el-button>
                  <el-button type="text" class="danger" @click="statusSingle(scope.row)" v-if="scope.row.status === 1">禁用</el-button>
                  <el-button type="text" class="success" @click="statusSingle(scope.row)" v-else-if="scope.row.status === 0">启用</el-button>
                  <el-button type="text" class="danger" @click="remove(scope.row)">删除</el-button>
                </div>
                <el-button type="text">
                  <i class="el-icon-more"></i>
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </template>
      </vue-table>
    </el-main>
    <el-footer class="footer-content">
      <vue-pagination :paging-data="pagingData" @table-reload="getTableList" ref="paging"></vue-pagination>
    </el-footer>
    <add-shop v-if="addShop.visible" :dialog-data="addShop" @table-reload="getTableList"/>
    <revise-shop v-if="reviseShop.visible" :dialog-data="reviseShop" @table-reload="getTableList"/>
    <admin-info v-if="adminInfo.visible" :dialog-data="adminInfo"/>
    <give-auth v-if="giveAuth.visible" :dialog-data="giveAuth" @table-reload="getTableList"/>
  </el-container>
</template>

<script>
  import {PagingData} from "@mixins"
  import Statistics from "@view/components/Statistics"
  import AddShop from "./dialog/AddShop"
  import ReviseShop from "./dialog/ReviseShop"
  import AdminInfo from "./dialog/AdminInfo"
  import GiveAuth from "./dialog/GiveAuth"
  import {shopStatus,settlementMode} from "@utils/formatList"
  import {getRegionNameByCode} from "@utils/location"
  import DateRangePicker from "@view/components/date/DateRangePicker"
  import RegionCascade from "@view/components/cascader/RegionCascade"
  export default {
    name: "shopList",
    mixins: [PagingData],
    components: {GiveAuth, Statistics,AddShop,ReviseShop,AdminInfo,DateRangePicker,RegionCascade},
    data() {
      return {
        settlementMode,
        // 查询项
        searchItem: {
          start_at: "",
          end_at: "",
          shop_id: this.$route.query.shop_id || "",
          code: "",
          mobile: "",
          name: "",
          region: "",
          settlement_mode: ""
        },
        commitItem: null,
        // 统计
        countList: [
          {name: "商家总数", count: 0},
        ],
        // 表格数据
        tableData: {
          tableList: [],
          tableColumn: [
            {label: "商户ID", property: "id", width: 70},
            {label: "门店名称", property: "name"},
            {label: "门店类型", property: "stype.name"},
            {label: "商户码", property: "code", width: 100},
            {label: "设备密钥", property: "device_key", width: 100},
            {label: "门店地区", property: "region"},
            {label: "用户总数 / 在线", property: "user_count", width: 120},
            {label: "设备总数 / 在线", property: "device_count", width: 120},
            {label: "短信总数 / 已使用", property: "sms_count", width: 140},
            {label: "授权总数 / 已使用", property: "auth_count", width: 140},
            // {label: "收款模式", property: "settlement_mode", format: settlementMode, width: 90},
            {label: "状态", property: "status", format: shopStatus, width: 70},
            {label: "管理员", property: "operate", width: 70},
          ],
          // 展开项
          hasExpand: true,
          expandLabelWidth: 120,
          expandColumn: [
            {label: "门店名称", property: "name"},
            {label: "商户码", property: "code"},
            {label: "设备密钥", property: "device_key"},
            {label: "门店地区", property: "region", formatFun: this.formatRegion},
            {label: "门店电话", property: "telephone"},
            {label: "门店邮箱", property: "email"},
            {label: "门店地址", property: "address"},
            {label: "门店介绍", property: "introduce"},
            {label: "状态", property: "status", format: shopStatus},
            {label: "创建时间", property: "create_at"},
            {label: "短信总数", property: "sms_count"},
            {label: "已使用短信", property: "sms_used"},
            {label: "授权总数", property: "user_count"},
            {label: "已使用授权", property: "user_used"},
            {label: "设备总数", property: "device_total"},
            {label: "在线设备", property: "device_online"},
            {label: "用户总数", property: "user_total"},
            {label: "在线用户", property: "user_online"},
          ]
        },
        addShop: {visible: false, width: 950, title: "添加商家"},
        reviseShop: {visible: false, width: 450, title: "修改商家"},
        adminInfo: {visible: false, width: 800, title: "查看管理员", row: null, hideBtn: true},
        giveAuth: {visible: false, width: 450, title: "增加授权", row: null},
      }
    },
    methods: {
      showAdmin(row) {
        this.adminInfo.visible = true;
        this.adminInfo.row = row;
      },
      formatRegion(row) {
        return getRegionNameByCode(row.region);
      },
      add() {
        this.addShop.visible = true;
      },
      revise(row) {
        this.reviseShop.visible = true;
        this.reviseShop.row = row;
      },
      remove(row) {
        this.openConfirm("删除该商家", async ()=> {
          let nv = {optionId: row.id};
          let res = await this.$Http.deleteShop(nv);
          if (res) {
            this.msgSuccess("删除成功");
            this.$refs["paging"].removeFinish(1);
            this.getTableList();
          }
        });
      },
      showGive(row) {
        this.giveAuth.visible = true;
        this.giveAuth.row = row;
      },
      async updateUser(row) {
        let nv = {shop_id: row.id};
        let res = await this.$Http.updateUser(nv);
        if (res) {
          this.msgSuccess("更新成功");
          this.getTableList();
        }
      },
      async remote(row) {
        let newPage = window.open();
        this.drawNewPage(newPage);
        let nv = {shop_id: row.id};
        let res = await this.$Http.remoteShop(nv);
        if (res?.data) {
          let obj =  res.data || {};
          let url = obj.shop_url + "/login";
          delete obj.shop_url;
          newPage.location.href = this.getUrl(url, obj);
        } else {
          newPage.close();
        }
      },
      statusSingle(row) {
        let status = row.status===1 ? 0 : 1;
        let msg = row.status===1 ? "禁用" : "启用";
        this.openConfirm(`${msg}该商家`, async ()=> {
          let nv = {
            status,
            optionId: row.id,
          };
          let res = await this.$Http.reviseShop(nv);
          if (res) {
            this.msgSuccess(`${msg}成功`);
            this.getTableList();
          }
        });
      },
      // 查询
      search() {
        this.commitItem = {...this.searchItem};
        this.pagingData.currentPage = 1;
        this.getTableList();
      },
      //获取表格数据
      async getTableList() {
        let nv = {
          page: this.pagingData.currentPage,
          limit: this.pagingData.pageSize,
        };
        // 添加筛选项
        this.copyObjValue(nv, this.commitItem);
        let res = await this.$Http.getShopList(nv);
        if (res?.data) {
          let total = +res.data.total || 0;
          this.pagingData.total = total;
          this.countList[0].count = total;
          this.tableData.tableList = this.getArray(res.data.list);
        }
      },
    },
    created() {
      this.search();
    }
  }
</script>

<style scoped>

</style>
